import React from 'react';
import { Accordion, Button } from '@agissc/ktag-map';
import { Datalist } from '@ktag/styleguide/dist/react';
import useAppState from '../../../../AppStore';
import { AccordionName } from '../../../../UIStateSlice';

interface TopicLayerAttributeSearchResultsAccordionItemProps {
  feature: any;
  isSelected: boolean;
  isHighlighted: boolean;
  dataListItems: { key: string; value: React.ReactNode }[];
  title: string;
  setHighlightedFeature: (featureId?: number) => void;
  setSelectedFeature: (feature: any) => void;
}

export const TopicLayerAttributeSearchResultsAccordionItem = ({
  feature,
  isSelected,
  isHighlighted,
  dataListItems,
  title,
  setHighlightedFeature,
  setSelectedFeature,
}: TopicLayerAttributeSearchResultsAccordionItemProps) => {
  const setAccordionItem = useAppState((state) => state.setAccordionItem);
  const expanded = useAppState(
    (state) =>
      !!state.accordions[AccordionName.ATTRIBUTESEARCH_CONFIGURATION]?.find(
        (i) => i.id === String(feature.id) && i.expanded,
      ),
  );
  const handleOnMouseEnter = () => {
    setHighlightedFeature(feature.id);
  };

  const handleOnMouseLeave = () => {
    setHighlightedFeature();
  };

  const onToggle = (isExpanded: boolean) => {
    setAccordionItem(
      AccordionName.ATTRIBUTESEARCH_CONFIGURATION,
      String(feature.id!),
      isExpanded,
    );
  };

  const handleOnCLick = () => {
    setSelectedFeature(feature);
  };

  return (
    <Accordion
      key={`${feature.id}-${expanded}`}
      title={
        <Button
          additionalClassNames={`title ${isHighlighted ? 'highlighted' : ''}`}
          onClick={handleOnCLick}
        >
          {title}
        </Button>
      }
      openIcon="chevron-down"
      closedIcon="chevron-up"
      open={expanded}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
      onToggle={onToggle}
      additionalClassNames={`${isSelected ? 'selected' : ''}`}
      disableTitleToggle
    >
      <Button onClick={handleOnCLick}>
        <Datalist
          className={`attribute-search__datalist ${isHighlighted ? 'highlighted' : ''}`}
          items={dataListItems}
        />
      </Button>
    </Accordion>
  );
};
